import React from 'react';
import { Text } from '@mantine/core';
import TermsPrivacyPageTemplate from './TermsPrivacyPageTemplate';
import Link from '../Link';

function TermsPage() {

  const content = {
    title: 'Terms & conditions',
    breadcrumb: 'Terms',
    subheading: <Text>Welcome to the <Text span fw={600}>Twiz</Text> music bingo game card generator! By using our website <Link href='/'>twiz.app</Link>, you agree to these terms of service.</Text>,
    href: '/terms',
    lastUpdated: 'March 10, 2025',
    sections: [
      {
        title: 'General conditions',
        subheading: null,
        bullets: [
            'You must be at least 18 years old to use our services.',
            'We reserve the right to modify or discontinue services at any time without notice.',
            'By placing an order, you agree to provide accurate and complete information.'
        ]
      },
      {
        title: 'Payments & billing',
        subheading: null,
        bullets: [
            <Text>We use <Link newTab href='https://www.stripe.com'>Stripe</Link> to process payments securely.</Text>,
            'Prices are listed in Canadian dollars ($ CAD) and may be subject to applicable taxes.',
            'We reserve the right to refuse or cancel any order if fraud or unauthorized activity is suspected.'
        ]
      },
      {
        title: 'Refunds & cancellations',
        subheading: null,
        bullets: [
            'Refund requests must be made within 7 days of purchase.',
            'If a refund is approved, funds will be returned via the original payment method.'
        ]
      },
      {
        title: 'Limitation of liability',
        subheading: 'We are not responsible for any direct, indirect, incidental, or consequential damages resulting from the use of our services.',
        bullets: []
      },
      {
        title: 'Contact information',
        subheading: <Text>For questions about these Terms, <Link href='?contact=true'>contact us</Link>.</Text>,
        bullets: []
      }
    ]
  };

  return (
    <TermsPrivacyPageTemplate content={content} />
  )

}

export default TermsPage;